import scrollIntoView from "scroll-into-view-if-needed";

function scrollTo(item) {
  scrollIntoView(item, { scrollMode: "if-needed", behavior: "smooth" });
}

export default scrollTo;



// WEBPACK FOOTER //
// ./utils/scrollTo.js